export const FeatureTitles = {
  Survey: "アンケート",
  AuthAuditLog: "認証ログ (β）",
  UserAuditLog: "ユーザー監査ログ",
};
